import { styled } from '@mui/material/styles';
import { TreeView as MuiTreeView } from '@mui/x-tree-view';

export const StyledTreeView = styled(MuiTreeView)(({ theme }) => ({
  '& .MuiTreeItem-root': {
    '&:focus > .MuiTreeItem-content': {
      backgroundColor: theme.palette.action.focus,
    },
    '&.Mui-selected > .MuiTreeItem-content': {
      backgroundColor: theme.palette.action.selected,
      '&:hover': {
        backgroundColor: theme.palette.action.selected,
      },
    },
  },
  '& .MuiTreeItem-content': {
    padding: theme.spacing(0.5, 1),
    margin: theme.spacing(0.2, 0),
    borderRadius: theme.shape.borderRadius,
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
    },
  },
  '& .MuiTreeItem-group': {
    marginLeft: 0,
    '& .MuiTreeItem-content': {
      paddingLeft: theme.spacing(2),
    },
  },
  '& .MuiTreeItem-label': {
    fontSize: theme.typography.body2.fontSize,
    fontWeight: theme.typography.body2.fontWeight,
  },
})); 